import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { Response } from 'services/api/types'
import { useAuth } from 'lib/auth'

type Data = {
  orderId: string
  sequence: string
  customerId: string
  paymentTermId: string
  productId: string
  configurationId: string
  quantity: number
  enabled?: boolean
  origin: number
  unityId: string
  sellerId: string
  saleTypeId: string
}

type Output = {
  defaultPrice: number
  defaultPrice4: number
  orderId: string
  icmsPercent: number
  icmsValue: number
  ipiPercent: number
  ipiValue: number
  stPercent: number
  stValue: number
  ruleId: number
  origin: number | null
}

export const loadOrderProductPrice = (data: Data): Response<Output> => {
  return axios.post(`/orders/products/price-formation`, data)
  // return new Promise((resolve) =>
  //   setTimeout(
  //     () =>
  //       resolve({
  //         data: {
  //           defaultPrice: 59.18,
  //           icmsPercent: 17,
  //           icmsValue: 10.06,
  //           ipiPercent: 0,
  //           ipiValue: 0,
  //           stPercent: 39,
  //           stValue: 23.08,
  //           orderId: 'ORC000001358'
  //         },
  //         date: '2023-03-22T16:29:37.042Z'
  //       }),
  //     10
  //   )
  // )
}

export function useLoadOrderProductPrice(query: Data) {
  const { user } = useAuth()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { enabled, orderId, quantity, ...cache } = query

  return useQuery(
    ['orderProductPrice', user?.id, cache],
    () => loadOrderProductPrice(query),
    {
      enabled:
        !!query.sequence &&
        !!query.customerId &&
        !!query.paymentTermId &&
        !!query.productId &&
        !!query.unityId &&
        !!query.sellerId &&
        !!query.saleTypeId &&
        query.enabled &&
        (query?.quantity || 0) > 0,
      keepPreviousData: false,
      onError: () =>
        toast.error('Não foi possível carregar o preço do produto!', {
          toastId: 'loadOrderProductPrice'
        })
    }
  )
}
